const faqs = [
  {
    q: '如何下载安装91精品影视APP？',
    a: '访问本页APP下载区域，点击"立即下载"按钮即可获取最新官方安装包。安卓用户下载APK文件后直接安装，iOS用户请按页面指引操作。安装完成后打开APP即可畅享海量影视资源。',
  },
  {
    q: '91精品影视APP是否需要付费？',
    a: '91精品影视APP基础版本完全免费使用，包含海量影视内容的在线观看和下载功能。部分独家高清内容可能需注册会员后解锁，具体以APP内实际展示为准。',
  },
  {
    q: '支持哪些设备和系统版本？',
    a: '91精品影视全面适配Android 7.0及以上系统、iOS 13及以上系统，同时支持平板设备和安卓模拟器。电脑端可通过网页版直接访问观看，多端进度自动同步。',
  },
  {
    q: '资源更新频率如何？能否追最新剧集？',
    a: '我们的内容团队全年无休，热门影视资源通常在播出后数小时内完成更新上架。剧集连载期间保持与播出平台同步更新节奏，确保你不会错过任何精彩内容。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题解答
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            你想了解的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto grid gap-4">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white rounded-xl border border-secondary-100 p-5 md:p-6">
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}